import { UmbrellaLogo } from "@/components/UmbrellaLogo";

const SECTIONS = [
  ["1. About Black Umbrella", [
    "Black Umbrella is an online marketplace that connects clients with independent, Black-owned businesses and trades across Canada. We are not a contractor and we do not perform the work ourselves. Each business listed on the platform is an independent operator responsible for the services it provides.",
    "By using Black Umbrella you agree to these Terms of Service. If you do not agree, please do not use the platform.",
  ]],
  ["2. Payments & escrow", [
    "All escrow payments are processed in Canadian Dollars (CAD) via Stripe. When a client accepts a quote, the agreed amount is paid into escrow and held securely before any work begins.",
    "When a job is completed through Black Umbrella, the client pays a 3% service fee and the business pays a 15% commission on the job total. Posting a job is free for clients.",
    "Funds held in escrow are released to the business once the client confirms the work has been completed as agreed, or in accordance with the dispute process below.",
  ]],
  ["3. Client responsibilities", [
    "Clients agree to describe jobs accurately, communicate respectfully, pay the agreed quote into escrow before work starts, and confirm completion promptly once the work is done to the agreed standard.",
    "Clients are responsible for providing safe and reasonable access to the job site and for any permits or approvals they are legally required to obtain.",
  ]],
  ["4. Business responsibilities", [
    "Businesses agree to provide accurate information about their company, licences and insurance; to complete work to a professional standard and as quoted; and to hold and maintain the licences, insurance and registrations required for their trade.",
    "Businesses are independent operators. Black Umbrella does not employ businesses and is not responsible for the work they perform.",
  ]],
  ["5. Disputes", [
    "If something goes wrong, either side can open a dispute before funds are released from escrow. When a dispute is opened, the funds remain held securely while the Black Umbrella team reviews the matter and helps both sides reach a fair resolution.",
    "We may request information, photos or other evidence from either party to help resolve a dispute.",
  ]],
  ["6. Limitation of liability", [
    "Black Umbrella provides the platform \"as is\" and acts only as an intermediary connecting clients and businesses. To the maximum extent permitted by law, Black Umbrella is not liable for the quality, safety, legality or outcome of any work performed by a business, nor for any indirect, incidental or consequential damages arising from use of the platform.",
    "Our total liability in connection with the platform is limited to the fees we received from you for the transaction giving rise to the claim.",
  ]],
  ["7. Changes to these terms", [
    "We may update these Terms of Service from time to time. Continued use of the platform after changes take effect means you accept the updated terms.",
  ]],
];

export default function Terms() {
  return (
    <div className="bg-white" data-testid="terms-page">
      <section className="relative brand-grid-bg">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 pt-16 pb-8">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-amber-600 bg-amber-500/10 px-3 py-1.5 rounded-full">
            <UmbrellaLogo size={14} /> Legal
          </span>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-950 leading-[1.05]">
            Terms of Service
          </h1>
          <p className="mt-4 text-slate-500">Plain-language terms for using Black Umbrella.</p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-8 py-10 space-y-10">
        {SECTIONS.map(([title, paras]) => (
          <div key={title}>
            <h2 className="font-heading text-xl font-bold text-slate-950">{title}</h2>
            <div className="mt-3 space-y-3">
              {paras.map((p, i) => (
                <p key={i} className="text-slate-600 leading-relaxed">{p}</p>
              ))}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
